/* eslint-disable @typescript-eslint/no-explicit-any */
import Qs from 'qs'
import service from '@/services/service'
import { APIBlacklist } from '@/models/api/blacklist.model'

const resource = {
    main: 'services',
    module: 'monitor-users'
}

export class MonitorServices {
    public static getSubscriptions (params: object) {
        return service.post(`${resource.main}/${resource.module}/subscriptions`, params)
    }

    public static deactivateSubscriptions (id: number) {
        return service.put(`${resource.main}/${resource.module}/subscriptions/deactivate/${id}`)
    }

    public static generateChargeSubscriptions (id: number) {
        return service.put(`${resource.main}/${resource.module}/subscriptions/generate-charge/${id}`)
    }

    public static getSubscriptionsHistory (params: object) {
        return service.post(`${resource.main}/${resource.module}/subscriptions-history`, params)
    }

    public static getBillSubscription (params: object) {
        return service.post(`${resource.main}/${resource.module}/subscriptions/bill`, params, { responseType: 'blob' })
    }

    public static exportSubscriptionsHistory (params: object) {
        return service.post(`${resource.main}/${resource.module}/subscriptions-history/export`, params)
    }

    public static getPresubscriptions (params: object) {
        return service.post(`${resource.main}/${resource.module}/presubscriptions`, params)
    }

    public static getBlacklist (params: object) {
        return service.get(`${resource.main}/${resource.module}/blacklist`, {
            params,
            paramsSerializer: (params: object) => {
                return Qs.stringify(params, { arrayFormat: 'indices' })
            }
        })
    }

    public static createBlacklist (params: APIBlacklist) {
        return service.post(`${resource.main}/${resource.module}/blacklist-add`, params)
    }

    public static deleteBlacklist (id: number) {
        return service.delete(`${resource.main}/${resource.module}/blacklist-remove/${id}`)
    }

    public static getMessages (params: object) {
        return service.post(`${resource.main}/${resource.module}/messages`, params)
    }

    public static exportMessages (params: object) {
        return service.post(`${resource.main}/${resource.module}/messages/export`, params)
    }

    public static getMonitorProviders (params: object) {
        return service.post(`${resource.main}/${resource.module}/providers`, params)
    }

    public static getMonitorProvidersList (carrierId: number, providerId?: number) {
        return service.get(`${resource.main}/${resource.module}/providers/list?carrierId=${carrierId}&providerId=${providerId}`)
    }

    public static getMonitorProvidersFilter (params: { carrierId?: number}) {
        if (params.carrierId) {
            return service.get(`${resource.main}/filters/providers?carrierId=${params.carrierId}`)
        } else {
            return service.get(`${resource.main}/filters/providers`)
        }
    }

    public static getMonitorShortcodesFilter (params: { carrierId?: number; providerId?: number }) {
        return service.get(`${resource.main}/filters/shortcodes?carrierId=${params.carrierId}&providerId=${params.providerId}`)
    }

    public static getMonitorProductsFilter (params: { carrierId?: number; providerId?: number }) {
        if (params.carrierId && params.providerId) {
            return service.get(`${resource.main}/filters/products?carrierId=${params.carrierId}&providerId=${params.providerId}`)
        } else {
            return service.get(`${resource.main}/filters/products`)
        }
    }

    public static getMonitorCarriersFilter () {
        return service.get(`${resource.main}/filters/carriers`)
    }
}
